var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4047_29220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.50736 1.00736 0.5 2.25 0.5H7.6287C8.2254 0.5 8.79773 0.737053 9.21968 1.15901L11.341 3.28033C11.7629 3.70229 12 4.27459 12 4.87132V13.25C12 14.4927 10.9927 15.5 9.75 15.5H2.25C1.00736 15.5 0 14.4927 0 13.25V2.75ZM2.25 2C1.83579 2 1.5 2.33579 1.5 2.75V13.25C1.5 13.6642 1.83579 14 2.25 14H9.75C10.1642 14 10.5 13.6642 10.5 13.25V4.87132C10.5 4.67241 10.4209 4.48164 10.2803 4.34099L8.15903 2.21967C8.01833 2.07902 7.8276 2 7.6287 2H2.25Z",
    fill: "#CD951B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.7866L3.30161 9.44789C3.86991 8.87039 4.79409 8.84856 5.389 9.39861L10 13.6616",
    stroke: "#CD951B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.25C4.74632 7.25 5.25 6.74632 5.25 6.125C5.25 5.50368 4.74632 5 4.125 5C3.50368 5 3 5.50368 3 6.125C3 6.74632 3.50368 7.25 4.125 7.25Z",
    fill: "#CD951B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_29220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleImageIcon);
export default __webpack_public_path__ + "static/media/littleImageIcon.2abed1e332059af9f52cc02e5fab325b.svg";
export { ForwardRef as ReactComponent };